// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.dashboard[data-v-0cc4289a] {\n  width: 100%;\n}\n.chk[data-v-0cc4289a] {\n  position: relative;\n  right: 24px;\n  bottom: 20px;\n  z-index: 2;\n  zoom: 2;\n}\n", ""]);
// Exports
module.exports = exports;
